// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1366px) {
    h1.MuiTypography-root{
        font-size: 45px;
    }
    h2.MuiTypography-root{
        font-size: 42px;
    }
    h3.MuiTypography-root{
        font-size: 36px;
    }
    h4.MuiTypography-root{
        font-size: 24px;
    }
    h5.MuiTypography-root{
        font-size: 20px;
    }
    h6.MuiTypography-root{
        font-size: 14px;
    }
    .btn-wrapper button.btn-small.only-icon-btn {
        min-width: 42px;
    }
    .btn-font-small .btn-wrapper button, .btn-font-small .btn-wrapper button:hover ,
    .right .btn-font-small .btn-wrapper button,.right .btn-font-small .btn-wrapper button:hover {
        font-size: 14px;
    }
    .right .btn-wrapper button.btn-small.only-icon-btn svg {
        width: 37px;
        height: 40px;
    }
    .profile-btn button {
        font-size: 12px;
        padding: 5px 12px;
    }
    .main-contant .card-footer .title,
    .main-contant .goal-set-box .title,
    .main-contant .my-patients-card-container .top-view .address {
        font-size: 12px;
    }
    .main-contant .card-footer .sub-title,
    .main-contant .goal-set-box .sub-title {
        font-size: 10px;
    }
    p.MuiTypography-root,
    .sidebar-menu-container .menu-div a{
        font-size: 14px;
    }
    .top-view .user-image-box {
        max-width: 65px;
    }
    .App .login-main{
        align-items: center;
    }
    .App .login-main .right-section .logo-box {
        margin: 1rem 0 1rem 0;
    }
    .login-main .login-details h2 {
        font-size: 34px;
    }
    .login-main .btn-wrapper button, .login-main .btn-wrapper button:hover {
        font-size: 18px;
    }
    .login-main .login-container .login-main .right-section {
        padding: 0 0 0 2rem;
    }
    
}
@media screen and (max-width: 1280px) {
    
}
@media screen and (max-width: 1200px) {
    
}
@media screen and (max-width: 1023px) {
    div .dashboard-container .left-container{
        left: -100%;
    }
    div .dashboard-container .right-container{
        margin-left: 0;
        width: 100%;
        padding: 20px 15px;
    }
    .left-section .header-menu-toggle{
        display: flex;
        align-items: center;
        gap: 0.254rem;
    }
    .profile-modal .btn-center {
        margin: 0 auto;
    }
}
@media screen and (max-width: 991px) {
    .left-section .search-input{
        width: 260px;
    }
    .mobile-logo img{
        max-width: 120px;
    }
    h1.MuiTypography-root{
        font-size: 40px;
    }
    h2.MuiTypography-root{
        font-size: 38px;
    }
    h3.MuiTypography-root{
        font-size: 30px;
    }
    h4.MuiTypography-root{
        font-size: 20px;
    }
    h5.MuiTypography-root{
        font-size: 18px;
    }
    h6.MuiTypography-root{
        font-size: 14px;
    }
    .App .login-container .login-main .left-section .heading {
        font-size: 28px;
    }
}
@media screen and (max-width: 767px) {
    .header-profile--wrapper .profile-image+span{
        display: none;
    }
    .right-section .header-profile--wrapper .profile-image{
        margin: 0;
    }
    .mobile-logo img{
        max-width: 90px;
    }
    .profile-btn button {
        padding: 5px 10px;
        font-size: 12px;
    }
    .dashboard-container .header-container .right-section {
        gap: 0.5rem;
    }
    .header-container .left-section form.MuiPaper-root{
        display: none;
    }
    .btn-font-small .btn-wrapper button, .btn-font-small .btn-wrapper button:hover ,
    .right .btn-font-small .btn-wrapper button,.right .btn-font-small .btn-wrapper button:hover {
        font-size: 12px;
        padding: 8px 10px;
    }
    .btn-font-small .btn-wrapper button .MuiButton-startIcon {
        margin-right: 4px;
    }
    .right .btn-wrapper button.btn-small.only-icon-btn {
        min-width: 38px;
    }
    .right .btn-wrapper button.btn-small.only-icon-btn svg {
        width: 32px;
        height: 35px;
    }
    .App .login-container .login-main .left-section {
        display: none;
    }
    .App .login-container .login-main .right-section {
        width: 100%;
        padding: 0;
    }
    .login-main .btn-wrapper button, .login-main .btn-wrapper button:hover {
    font-size: 16px;
    }
    .login-main .login-details h2 {
        font-size: 26px;
    }
    .login-container .login-main {
        min-height: calc(100vh - 40px);
    }
    .App .login-container {
        padding: 20px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/Assets/Css/Responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;;;QAGI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;;AAEJ;AACA;;AAEA;AACA;;AAEA;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;;QAEI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;IACA,eAAe;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media screen and (max-width: 1366px) {\n    h1.MuiTypography-root{\n        font-size: 45px;\n    }\n    h2.MuiTypography-root{\n        font-size: 42px;\n    }\n    h3.MuiTypography-root{\n        font-size: 36px;\n    }\n    h4.MuiTypography-root{\n        font-size: 24px;\n    }\n    h5.MuiTypography-root{\n        font-size: 20px;\n    }\n    h6.MuiTypography-root{\n        font-size: 14px;\n    }\n    .btn-wrapper button.btn-small.only-icon-btn {\n        min-width: 42px;\n    }\n    .btn-font-small .btn-wrapper button, .btn-font-small .btn-wrapper button:hover ,\n    .right .btn-font-small .btn-wrapper button,.right .btn-font-small .btn-wrapper button:hover {\n        font-size: 14px;\n    }\n    .right .btn-wrapper button.btn-small.only-icon-btn svg {\n        width: 37px;\n        height: 40px;\n    }\n    .profile-btn button {\n        font-size: 12px;\n        padding: 5px 12px;\n    }\n    .main-contant .card-footer .title,\n    .main-contant .goal-set-box .title,\n    .main-contant .my-patients-card-container .top-view .address {\n        font-size: 12px;\n    }\n    .main-contant .card-footer .sub-title,\n    .main-contant .goal-set-box .sub-title {\n        font-size: 10px;\n    }\n    p.MuiTypography-root,\n    .sidebar-menu-container .menu-div a{\n        font-size: 14px;\n    }\n    .top-view .user-image-box {\n        max-width: 65px;\n    }\n    .App .login-main{\n        align-items: center;\n    }\n    .App .login-main .right-section .logo-box {\n        margin: 1rem 0 1rem 0;\n    }\n    .login-main .login-details h2 {\n        font-size: 34px;\n    }\n    .login-main .btn-wrapper button, .login-main .btn-wrapper button:hover {\n        font-size: 18px;\n    }\n    .login-main .login-container .login-main .right-section {\n        padding: 0 0 0 2rem;\n    }\n    \n}\n@media screen and (max-width: 1280px) {\n    \n}\n@media screen and (max-width: 1200px) {\n    \n}\n@media screen and (max-width: 1023px) {\n    div .dashboard-container .left-container{\n        left: -100%;\n    }\n    div .dashboard-container .right-container{\n        margin-left: 0;\n        width: 100%;\n        padding: 20px 15px;\n    }\n    .left-section .header-menu-toggle{\n        display: flex;\n        align-items: center;\n        gap: 0.254rem;\n    }\n    .profile-modal .btn-center {\n        margin: 0 auto;\n    }\n}\n@media screen and (max-width: 991px) {\n    .left-section .search-input{\n        width: 260px;\n    }\n    .mobile-logo img{\n        max-width: 120px;\n    }\n    h1.MuiTypography-root{\n        font-size: 40px;\n    }\n    h2.MuiTypography-root{\n        font-size: 38px;\n    }\n    h3.MuiTypography-root{\n        font-size: 30px;\n    }\n    h4.MuiTypography-root{\n        font-size: 20px;\n    }\n    h5.MuiTypography-root{\n        font-size: 18px;\n    }\n    h6.MuiTypography-root{\n        font-size: 14px;\n    }\n    .App .login-container .login-main .left-section .heading {\n        font-size: 28px;\n    }\n}\n@media screen and (max-width: 767px) {\n    .header-profile--wrapper .profile-image+span{\n        display: none;\n    }\n    .right-section .header-profile--wrapper .profile-image{\n        margin: 0;\n    }\n    .mobile-logo img{\n        max-width: 90px;\n    }\n    .profile-btn button {\n        padding: 5px 10px;\n        font-size: 12px;\n    }\n    .dashboard-container .header-container .right-section {\n        gap: 0.5rem;\n    }\n    .header-container .left-section form.MuiPaper-root{\n        display: none;\n    }\n    .btn-font-small .btn-wrapper button, .btn-font-small .btn-wrapper button:hover ,\n    .right .btn-font-small .btn-wrapper button,.right .btn-font-small .btn-wrapper button:hover {\n        font-size: 12px;\n        padding: 8px 10px;\n    }\n    .btn-font-small .btn-wrapper button .MuiButton-startIcon {\n        margin-right: 4px;\n    }\n    .right .btn-wrapper button.btn-small.only-icon-btn {\n        min-width: 38px;\n    }\n    .right .btn-wrapper button.btn-small.only-icon-btn svg {\n        width: 32px;\n        height: 35px;\n    }\n    .App .login-container .login-main .left-section {\n        display: none;\n    }\n    .App .login-container .login-main .right-section {\n        width: 100%;\n        padding: 0;\n    }\n    .login-main .btn-wrapper button, .login-main .btn-wrapper button:hover {\n    font-size: 16px;\n    }\n    .login-main .login-details h2 {\n        font-size: 26px;\n    }\n    .login-container .login-main {\n        min-height: calc(100vh - 40px);\n    }\n    .App .login-container {\n        padding: 20px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
